/**
 * Normalizes the provided headers input into a plain JavaScript object containing string key-value pairs.
 *
 * @param {HeadersInit} [input] - The headers input to be normalized. This can be an instance of `Headers`,
 * an array of key-value pairs, or a plain object.
 * @return {Record<string, string>} A normalized object where each header key corresponds to its value as a string.
 */
export function normalizeHeaders(input?: HeadersInit): Record<string, string> {
  const headers: Record<string, string> = {};

  if (!input) return headers;

  if (input instanceof Headers) {
    input.forEach((value, key) => {
      headers[key] = value;
    });
  } else if (Array.isArray(input)) {
    input.forEach(([key, value]) => {
      headers[key] = value;
    });
  } else {
    Object.assign(headers, input);
  }

  return headers;
}
